<template>
  <div class="h5 font-weight-bold text-dark bg-light p-4 border rounded">
    <div class="d-flex justify-content-between align-items-center" v-if="hasControl">
      <div class="d-flex flex-column">
        <label v-if="label" :for="controlId" class="mb-2 font-weight-bold">
          {{ label }}
          <span v-if="required" class="required-field" aria-hidden="true"> *</span>
        </label>
        <span v-if="statusText" class="text-dark-secondary small">
          <em>{{ statusText }}</em>
        </span>
      </div>
      <div class="ml-3">
        <slot name="control"></slot>
      </div>
    </div>
    <div class="d-flex flex-column" v-else>
      <label v-if="label" :for="controlId" class="mb-2 font-weight-bold">
        {{ label }}
        <span v-if="required" class="required-field" aria-hidden="true"> *</span>
      </label>
      <span v-if="readOnlyValue" class="text-dark-secondary">
        {{ readOnlyValue }}
      </span>
      <slot v-else></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCardWrapper',
  props: {
    label: {
      type: String,
      default: ''
    },
    controlId: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    statusText: {
      type: String,
      default: ''
    },
    hasControl: {
      type: Boolean,
      default: false
    },
    readOnlyValue: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.required-field {
  color: red;
}

.required-field::after {
  content: " (obligatoire)";
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

/* Couleur avec contraste amélioré pour le texte secondaire */
.text-dark-secondary {
  color: #5a6268 !important;
}
</style>